import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        maxWidth: 564,
        width: 'calc(100% - 32px)',
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

export const TabErrorDot = styled('span')({
    display: 'inline-block',
    width: 6,
    height: 6,
    marginLeft: 6,
    borderRadius: '50%',
    verticalAlign: 'middle',
    backgroundColor: 'var(--error-main)',
});

export const TabsWrapper = styled('div')({
    overflowX: 'auto',
    height: 32,
    marginBottom: 24,
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
});

export const StyledRadioButtons = styled(RadioButtonsGroup)({
    width: '100%',
    display: 'block',
    marginBottom: '24px',
    '& .MuiFormControlLabel-root': {
        height: '32px',
        padding: '0 4px',
    },
});
